// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"32044500","124":"821b16d7","204":"a06c2549","283":"1d782401","412":"66a10ced","453":"6a506b61","824":"23a3c1ae","891":"ba9e99eb"}[chunkId] + ".chunk.js";
};